import { useProfileStore } from '../services/profile-service/service-store/service-store';
import { profileServiceAvailablePagesSelector } from '../services/profile-service/service-store/selectors';
import { useBreakpoints } from './use-breakpoints';
import { checkEqual } from '../helpers/checkEqual';
export var useAvailablePageData = function () {
    var availablePagesDto = useProfileStore(profileServiceAvailablePagesSelector, checkEqual);
    var screenData = useBreakpoints();
    return {
        pageData: availablePagesDto,
        screenData: screenData,
    };
};
